import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, type JSX } from "react";

import { useAuth } from "@/shared/auth";

// The root path is not a landing page — send users straight into the app:
// authenticated → dashboard (post-login home), otherwise → login.
function HomePage(): JSX.Element {
  const { isAuthenticated, status } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (status === "pending") return;
    void navigate({ to: isAuthenticated ? "/dashboard" : "/login", replace: true });
  }, [isAuthenticated, status, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <span className="text-sm text-[var(--text-subtle)]" />
    </div>
  );
}

export const Route = createFileRoute("/")({ component: HomePage });
